"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propsMain = _interopRequireDefault(require("./props-main"));
var _setControl = _interopRequireDefault(require("./set-control"));
var _default = exports.default = [_setControl.default, _propsMain.default];